import React, { useState, useEffect, useRef } from 'react';

let pushHandler = null;

function subscribe(handler) {
  pushHandler = handler;
}

let idCounter = 0;

// type: 'success' | 'error' | 'info'
export function uiToast(message, type = 'info', durationMs = 4000) {
  idCounter += 1;
  const toast = { id: idCounter, message, type, durationMs };
  if (pushHandler) pushHandler(toast);
}

export const uiToastSuccess = (message) => uiToast(message, 'success');
export const uiToastError = (message) => uiToast(message, 'error');

export function ToastHost() {
  const [toasts, setToasts] = useState([]);
  const timers = useRef({});

  useEffect(() => {
    subscribe((toast) => {
      setToasts((prev) => [...prev, toast]);
      timers.current[toast.id] = setTimeout(() => {
        setToasts((prev) => prev.filter((t) => t.id !== toast.id));
        delete timers.current[toast.id];
      }, toast.durationMs);
    });
    return () => {
      subscribe(null);
      Object.values(timers.current).forEach(clearTimeout);
    };
  }, []);

  const dismiss = (id) => {
    clearTimeout(timers.current[id]);
    delete timers.current[id];
    setToasts((prev) => prev.filter((t) => t.id !== id));
  };

  if (toasts.length === 0) return null;

  return (
    <div className="toast-stack">
      {toasts.map((t) => (
        <div key={t.id} className={`toast toast-${t.type}`} onClick={() => dismiss(t.id)}>
          {t.message}
        </div>
      ))}
    </div>
  );
}
